import { render, staticRenderFns } from "./PWABanner.vue?vue&type=template&id=4388fe62&scoped=true"
import script from "./PWABanner.vue?vue&type=script&lang=js"
export * from "./PWABanner.vue?vue&type=script&lang=js"
import style0 from "./PWABanner.vue?vue&type=style&index=0&id=4388fe62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4388fe62",
  null
  
)

export default component.exports